import React from 'react';

const Info = () => {
    return (
        <div className="about__info grid">
            <div className="about__box">
                <i class='bx bx-award about__icon' ></i>
                <h3 className="about__title"> Experience </h3>
                <span className="about__subtitle">More than 5 years of hands-on experience</span>
            </div>

            <div className="about__box">
                {/*Enter moving on place with bx-tada */}
                <i class='bx bx-briefcase-alt about__icon'></i>
                <h3 className="about__title"> Completed </h3>
                <span className="about__subtitle">Successfully develop 20+ projects</span>
            </div>

            <div className="about__box">
                <i class='bx bx-support about__icon' ></i>
                <h3 className="about__title"> Support </h3>
                <span className="about__subtitle">Available online during business hours</span>
            </div>
        </div>
    )
}

export default Info